{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "大小上限為 {size}。僅允許 {imageLimit}、{typeLimitText}、{typeLimitZip} 或 {typeLimitSpreadsheet}。如需上傳多份文件，請先壓縮成 zip 再上傳。",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "每個檔案大小上限為 {size}。最多 {count} 個檔案。僅允許 {image}、{text}、{zip} 或 {spreadsheet}。",
    "oneImage": "一張圖片",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "上傳文件",
    "uploadDocuments": "上傳文件"
  }
}
